<div style="margin-top: 1em;">
  <p-card>
    <ng-template pTemplate="title">
      <div>
        <p class="text-center font-weight-light">{{ title }}</p>
      </div>
    </ng-template>
    <!-- <ng-template pTemplate="subtitle">
        <span>{{ title }}</span>
    </ng-template> -->
    <br>
    <ng-template pTemplate="content">
      <h1 class="text-center font-bold">{{ code }}</h1>
    </ng-template>

    <!-- <ng-template pTemplate="footer">
        footer
    </ng-template> -->

  </p-card>
</div>
